const roles = {
    super: 'super',
    admin: 'admin',
    vendor: 'vendedor'
};

export default roles;